import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Renders a post body or sign-off, which are HTML written in the admin editor
 * and sanitised by the backend before they are stored (see backend/blog.py).
 *
 * Links inside that HTML are plain anchors, so a link from one post to another
 * would otherwise reload the whole app. Clicks on same-site links are caught
 * here and handed to the router instead, which keeps navigation instant and
 * leaves middle-click, ctrl-click and external links behaving normally.
 */
const PostBody = ({ html, className, style, onImageClick }) => {
    const navigate = useNavigate();

    const handleClick = useCallback((e) => {
        // A picture in the text opens large instead.
        if (onImageClick && e.target.tagName === 'IMG') {
            onImageClick(e.target.currentSrc || e.target.src, e.target.alt || '');
            return;
        }
        const link = e.target.closest('a');
        if (!link) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        const href = link.getAttribute('href') || '';
        if (!href.startsWith('/')) return;
        e.preventDefault();
        navigate(href);
    }, [navigate, onImageClick]);

    return (
        <div
            className={className}
            style={style}
            onClick={handleClick}
            dangerouslySetInnerHTML={{ __html: html || '' }}
        />
    );
};

export default PostBody;
